import React from 'react';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../utils/constants/form-message-constants';

function TicketModalBody({
    printTicketModalText,
    ticketForPrint,
    ticketType,
    ticketId,
    firstName,
    firstNameValue,
    lastName,
    lastNameValue
}) {
    return (
        <div className='ticket-print-confirm-modal'>
            <h2>{printTicketModalText}</h2>
            <div className='ticket-print-confirm-modal-container'>
                <p>
                    <span className='left'>{formMessageConstants.type}</span>
                    <span className='right'>{ticketForPrint &&
                        ticketType}</span>
                </p>
                <p>
                    <span className='left'>{formMessageConstants.ticketNumber}</span>
                    <span className='right'>{ticketForPrint &&
                        ticketId}</span>
                </p>
                <p>
                    <span className='left'>{firstName}</span>
                    <span className='right'>{firstNameValue}</span>
                </p>
                <p>
                    <span className='left'>{lastName}</span>
                    <span className='right'>{lastNameValue}</span>
                </p>
            </div>
        </div>
    );
}

TicketModalBody.propTypes = {
    printTicketModalText: PropTypes.string,
    ticketForPrint: PropTypes.object,
    ticketType: PropTypes.string,
    ticketId: PropTypes.number,
    firstName: PropTypes.string,
    firstNameValue: PropTypes.string,
    lastName: PropTypes.string,
    lastNameValue: PropTypes.string
};

export default TicketModalBody;
